import createIcon from '../../createIcon';

/**
 * @component @name ContactPage
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTQgMkg2QzQuOSAyIDQgMi45IDQgNFYyMEM0IDIxLjEgNC45IDIyIDYgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhMMTQgMlpNMTIgMTBDMTMuMSAxMCAxNCAxMC45IDE0IDEyQzE0IDEzLjEgMTMuMSAxNCAxMiAxNEMxMC45IDE0IDEwIDEzLjEgMTAgMTJDMTAgMTAuOSAxMC45IDEwIDEyIDEwWk0xNiAxOEg4VjE3LjQzQzggMTYuNjIgOC40OCAxNS45IDkuMjIgMTUuNThDMTAuMDcgMTUuMjEgMTEuMDEgMTUgMTIgMTVDMTIuOTkgMTUgMTMuOTMgMTUuMjEgMTQuNzggMTUuNThDMTUuNTIgMTUuOSAxNiAxNi42MiAxNiAxNy40M1YxOFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ContactPage = createIcon('ContactPage', [
  [
    'path',
    {
      d: 'M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2ZM12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10ZM16 18H8V17.43C8 16.62 8.48 15.9 9.22 15.58C10.07 15.21 11.01 15 12 15C12.99 15 13.93 15.21 14.78 15.58C15.52 15.9 16 16.62 16 17.43V18Z',
      key: 'm78ptb',
    },
  ],
]);

export default ContactPage;
